module.exports = "<div>\n  <input\n    multiple-select\n    options=\"options\"\n    max-select-limit=\"3\"\n    ng-model=\"model\"\n  />\n</div>";